export default [
  { size: '320x568', name: 'iPhone5/SE（320x568）' },
  { size: '375x667', name: 'iPhone6/7/8（375x667）' },
  { size: '414x736', name: 'iPhone6/7/8 plus（414x736）' },
  { size: '375x812', name: 'iPhone X（375x812）' },
  { size: '768x1024', name: 'iPad（768x1024）' },
  { size: '1024x1366', name: 'iPad pro（1024x1366）' },
  { size: '360x640', name: 'Galaxy S5（360x640）' },
  // { size: '1920x1080', name: 'PC（1920x1080）' }
]
